import { FC, useEffect, useState } from 'react';
import { t } from "../app/Translate";
import { Link, useNavigate } from 'react-router-dom';

interface HeaderProps{
    isocode: string  
    active:string;  
}

const Header: FC<HeaderProps> = ({ isocode, active }) => {       
    const [opacity, setOpacity] = useState(0);
    const navigate = useNavigate();

    const handleClick = () => {    
        // Despliega el menu de la izq.    
        let element = document.getElementById("layout-menu")!
        let wrapperelement = document.getElementById("wrapper")!
        element.classList.add("display-nav")    
        wrapperelement.classList.add("active")
    };

    const handlewrapperClick = () => {
        let element = document.getElementById("layout-menu")!
        element.classList.remove("display-nav")      
        let wrapperelement = document.getElementById("wrapper")!                
        wrapperelement.classList.remove("active")              
    }

    function NavigateTo(){
        let urlRegister = "/" + isocode + "/plans/" 
        navigate(urlRegister);
    }

    useEffect(() => {
        const handleScroll = () => {
        // Calcula opacidad entre 0 y 1 según scrollY (máx 200px)
        const newOpacity = Math.min(window.scrollY / 400, 1);
            setOpacity(newOpacity);
        };


        window.addEventListener("scroll", handleScroll);

        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return(
        <>
            <div className='header-mainbar' style={{
                    position: "fixed",
                    top: 0,
                    left: 0,                    
                    width: "100%",                
                    backgroundColor: `rgba(40, 44, 64, ${opacity})`,
                    boxShadow: opacity > 0 ? "0 2px 10px rgba(0,0,0,0.2)" : "none",
                    transition: "background-color 0.1s",
                    zIndex: 1000,
                }}>
                <div className='img-menu' onClick={handleClick}>                    
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 32 32"
                        strokeWidth={2}
                        stroke="currentColor"                        
                        style={{width:"32px"}}
                        >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M4 6h16M4 12h16M4 18h16"
                        />
                    </svg>
                </div>

                <div className='header-logomain ml-10'>                                                    
                    <img className="nav-logo" src="/images/Logo-Makos.png" alt='Makos' />
                </div>

                <aside id="layout-menu" className="menu-horizontal">
                    <div className='img-menu-open' onClick={handlewrapperClick}>                        
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={2}
                            stroke="currentColor"
                            style={{width:"32px"}}
                            >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M6 18L18 6M6 6l12 12"
                            />
                        </svg>

                    </div>
                    <div className="container-menu d-flex"> 
                        <div className="menu-horizontal-wrapper">
                            <ul className="nav-menu">
                                <li className="nav-item">
                                    <Link to={`/${isocode}/`}  className={`nav-link ${active === "home" ? "active" : ""}`}>{t("menu.home")}</Link>                                                                        
                                </li>
                                <li className="nav-item dropdown">
                                    <a href="#" className={`nav-link ${active === "functions" ? "active" : ""}`}> {t("menu.functions")}</a>
                                    <div className="dropdown-content">
                                        <Link to={`/${isocode}/invoice`} className="dropdown-item">{t("menu.functions-invoices")}</Link>
                                        <Link to={`/${isocode}/inventory`} className="dropdown-item">{t("menu.functions-inventory")}</Link>
                                        <Link to={`/${isocode}/treasury`} className="dropdown-item">{t("menu.functions-treasury")}</Link>
                                        <Link to={`/${isocode}/accounting`} className="dropdown-item">{t("menu.functions-gestion")}</Link>
                                        <Link to={`/${isocode}/statements`} className="dropdown-item">{t("menu.functions-informs")}</Link>                                                                            
                                    </div>
                                </li>
                                <li className="nav-item">                                                                        
                                    <Link to={`/${isocode}/advanced`}  className={`nav-link ${active === "advanced" ? "active" : ""}`}>{t("menu.advantage")}</Link>                                    
                                </li>
                                <li className="nav-item">
                                    <Link to={`/${isocode}/plans`}  className={`nav-link ${active === "plans" ? "active" : ""}`}>{t("menu.plans")}</Link>                                    
                                </li>
                                <li className="nav-item">
                                    <Link to={`/${isocode}/faq`}  className={`nav-link ${active === "faq" ? "active" : ""}`}>{t("menu.FAQS")}</Link>                                    
                                </li>
                            </ul>
                        </div>
                    </div>
                </aside>

                <div className="profile-icon onlydesktop">
                    <button onClick={NavigateTo} className="animated-button">{t("menu.CTA")}</button>
                </div>
            </div>

            <div id="wrapper" onClick={handlewrapperClick}></div> 
            <div className="overlay" id="overlay"></div>
        </>
    )
}


export default Header;